export default __webpack_public_path__ + "static/media/drugs.700e1a2a.jpg";